import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Channel } from 'ops/common/models/channel';
import { ChannelGroup } from 'ops/common/models/channel-group';
import { CustomGroup } from 'ops/common/models/custom-group';
import { TrendGraphView } from 'ops/common/models/trend-graph-view';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    constructor(private router: Router) {}

    toChannelGroup(group: ChannelGroup) {
        this.router.navigate(['/ops', 'groups', group.id, 'channels']);
    }

    toChannelDetails(channel: Channel, group?: ChannelGroup | CustomGroup) {
        let groupId = group?.id ?? channel.groupId;
        this.router.navigate(['/ops', 'groups', groupId, 'channels', channel.fcuData.fcuChannelId]);
    }

    toCustomChannelGroup(group: CustomGroup) {
        this.router.navigate(['/ops', 'groups', group.id, 'channels']);
    }

    toTrendGraphView(id: string) {
        this.router.navigate(['/ops', 'graphs', id]);
    }

    toTrendGraphCreate(view?: TrendGraphView) {
        this.router.navigate(['/ops', 'graphs', 'create'], { state: { view } });
    }

    toAlarms() {
        this.router.navigate(['/ops', 'alarms']);
    }

    toMimic(id: string) {
        this.router.navigate(['/ops', 'mimics'], { queryParams: { id: id } });
    }
}
